import React from "react";
import Accordion from "../../../common/accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import { LABELS } from "../../../../constants/labels/help.labels";

const Motor: React.FC = () => {
    const {
        motorCalculationsCollapse,
        motorPerformmanceDataCollapse,
        motorRatingCollapse,
        fluidVelocityCheckCollapse
    } = useAppSelector((state) => state?.collapse);
    const {
        updateMotorCalculationsCollapse,
        updateMotorPerformmanceDataCollapse,
        updateMotorRatingCollapse,
        updateFluidVelocityCheckCollapse
    } = useCollapseFacade();

    const handleCollapseChange = (key: boolean, name: string) => {
        if (name === "MotorCal") updateMotorCalculationsCollapse(key);
        else if (name === "MotorPerformanceCal") updateMotorPerformmanceDataCollapse(key);
        else if (name === "MotorDeratingCal") updateMotorRatingCollapse(key);
        else if (name === "FluidVel") updateFluidVelocityCheckCollapse(key);
    };

    return (
        <div className="flex flex-col justify-center item-center w-full h-full gap-[16px] text-neutral-25">
            <Accordion
                title={LABELS?.motorCalculations}
                isOpen={!motorCalculationsCollapse}
                id={'MotorCal'}
                link={'/help?tab=Motor#MotorCal'}
                onToggle={() => handleCollapseChange(!motorCalculationsCollapse, "MotorCal")}
                content={
                    <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
                        <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                            <table className="w-full table table-striped table-bordered dtr-inline">
                                <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%" }} />
                                </colgroup>
                                <tr className="align-center border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                                    <th className='px-[24px] py-[16px] align-center font-normal'>Total power required (hp @ operating-frequency) Hz </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="pb-4 secondary">
                                            totbasicGasHP + (chgPmp1Val
                                            + chgPmp2Val + chgPmp3Val)
                                        </div>
                                        <div className="pb-4 secondary">
                                            totbasicGasHP= pmpTotBHP
                                        </div>
                                        <div className="pb-4 secondary">
                                            noOfGasSep greater than 0
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary-text">
                                                totbasicGasHP1 = (
                                                GasSeparatorsPowerRating
                                                * noOfGasSep ) +
                                                pmpTotBHP
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                useOfChPmp is selected
                                            </p>
                                            <p className="secondary-text">
                                                totbasicGasHP2 =
                                                totbasicGasHP1 +
                                                GasHandlersPowerRating
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                lwrHP is not selected
                                            </p>
                                            <p className="secondary-text">
                                                totbasicGasHP3 =
                                                totbasicGasHP2 +
                                                lwrHPVal;
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                uprHPVal is not selected
                                            </p>
                                            <p className="secondary-text">
                                                totbasicGasHP4 =
                                                totbasicGasHP3 +
                                                uprHPVal
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ChPmpSelVal is selected
                                            </p>
                                            <p className="secondary-text">
                                                chgPmp1Val =
                                                CP1_HPRating
                                            </p>
                                            <p className="secondary-text">
                                                chgPmp2Val =
                                                CP2_HPRating
                                            </p>
                                            <p className="secondary-text">
                                                chgPmp3Val =
                                                CP3_HPRating
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary">
                                                totbasicGasHP =
                                                totbasicGasHP4
                                            </p>
                                        </div>
                                    </td>
                                    <th className='px-[24px] py-[16px] align-center font-normal'>(hp @ 60 Hz) </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="pb-4 secondary">
                                            (mtrval * 60) / opFreqval
                                        </div>
                                        <div className="pb-4 secondary">
                                            totbasicGasHP1 = (
                                            GasSeparatorsPowerRating *
                                            noOfGasSep ) + val1
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                noOfGasSep greater than
                                                0</p>
                                            <p className="secondary-text">
                                                totbasicGasHP1 = (
                                                GasSeparatorsPowerRating
                                                * noOfGasSep ) + val1
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                useOfChPmp is selected
                                            </p>
                                            <p className="secondary-text">
                                                chPmpHP =
                                                GasHandlersPowerRating
                                            </p>
                                            <p className="secondary-text">
                                                opFreqval = operatngFreq
                                            </p>
                                            <p className="secondary-text">
                                                chPmpVal60 = ((chPmpHP *
                                                60) / opFreqval)
                                            </p>
                                            <p className="secondary-text">
                                                totbasicGasHP =
                                                totbasicGasHP1 +
                                                chPmpVal60
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                lwrHP is not selected
                                            </p>
                                            <p className="secondary-text">
                                                totbasicGasHP2 =
                                                totbasicGasHP + lwrHPVal
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                uprHPVal is not selected
                                            </p>
                                            <p className="secondary-text">
                                                totbasicGasHP =
                                                totbasicGasHP2 +
                                                uprHPVal
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                totbasicGasHP is greater
                                                than 0</p>
                                            <p className="secondary-text pb-4">
                                                totbasicGasHP
                                            </p>
                                            <p className="secondary">
                                                Else</p>
                                            <p className="secondary-text">
                                                0
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary">
                                                autoHpMotor is 0 </p>
                                            <p className="secondary">
                                                opFreqval is not
                                                selected </p>
                                            <p className="secondary-text">
                                                tot60Hzval2 = ((mtrval *
                                                60) / opFreqval)
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="align-center text-[14px] font-normal">
                                    <th className='px-[24px] py-[16px] align-center font-normal'>
                                        KW<small>out</small>
                                    </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="secondary">
                                            <p>
                                                V<small>d</small> * I<small>d</small> * PF<small>d</small> *
                                                <span>&#8730;</span>3 / 1000
                                            </p>
                                        </div>
                                    </td>

                                    <th className='px-[24px] py-[16px] align-center font-normal'></th>
                                    <td className='px-[24px] py-[16px]'></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                }
            ></Accordion>
            <Accordion
                title={LABELS?.motorPerformmanceData}
                isOpen={!motorPerformmanceDataCollapse}
                id={'MotorPerformanceCal'}
                link={'/help?tab=Motor#MotorPerformanceCal'}
                onToggle={() => handleCollapseChange(!motorPerformmanceDataCollapse, "MotorPerformanceCal")}
                content={
                    <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
                        <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                            <table className="w-full table table-striped table-bordered dtr-inline">
                                <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%" }} />
                                </colgroup>
                                <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                                    <th className='px-[24px] py-[16px] align-center font-normal'>
                                        Efficiency
                                    </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="pb-4 secondary">
                                            Efficiency = E0 + E1 * MotorLoad + E2 * (MotorLoad^2) + E3 * (MotorLoad^3) + E4
                                            * (MotorLoad^4) + E5 * (MotorLoad^5);
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                            </p>
                                            <p className="secondary-text">
                                                MotorLoad = TotalBHP / (motorHP * frequency / 60);
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                NamePlateEfficiency (E0,E1,E2,E3,E4,E5):
                                            </p>
                                            <p className="secondary-text">
                                                Selected motor efficiency from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                TotalBHP :
                                            </p>
                                            <p className="secondary-text">
                                                Total power required @ opearting frequency - Motor tab
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary">
                                                motorHP :
                                            </p>
                                            <p className="secondary-text">
                                                motorHP = deratingPerformance.HP;
                                            </p>
                                        </div>
                                    </td>
                                    <th className='px-[24px] py-[16px] align-center font-normal'>
                                        Motor load (%NP)
                                    </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="pb-4 secondary">
                                            Speed = S0 + S1 * MotorLoad + S2 * (MotorLoad^2) + S3 * (MotorLoad^ 3) + S4 *
                                            (MotorLoad^4) + S5 * (MotorLoad^5)
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary-text">
                                                MotorLoad = TotalBHP / (motorHP * frequency / 60);
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                NamePlateSpeed (S0,S1,S2,S3,S4,S5):
                                            </p>
                                            <p className="secondary-text">
                                                Selected motor speed from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary">
                                                TotalBHP :
                                            </p>
                                            <p className="secondary-text">
                                                Total power required @ opearting frequency - Motor tab
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                                    <th className='px-[24px] py-[16px] align-center font-normal'>
                                        Operating temp °F
                                    </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="pb-4 secondary">
                                            OperatingTemp = finalOpTime
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                finalOpTime = HeatRise + OpTemp
                                            </p>
                                            <p className="secondary-text">
                                                OpTemp = bottomholeTemp
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                HeatRise = H0 + H1 * MotorLoad + H2 * (MotorLoad^2) + H3 * (MotorLoad^3) +
                                                H4 *(MotorLoad^ 4) + H5 * (MotorLoad^5);
                                            </p>
                                            <p className="secondary">
                                                NamePlate (H0,H1,H2,H3,H4,H5)
                                            </p>
                                            <p className="secondary-text">
                                                Selected motor HeatRise from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorLoad = TotalBHP / (motorHP * frequency / 60);
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                TotalBHP :
                                            </p>
                                            <p className="secondary-text">
                                                Total power required @ opearting frequency - Motor tab
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary">
                                                motorHP :
                                            </p>
                                            <p className="secondary-text">
                                                motorHP = deratingPerformance.HP;
                                            </p>
                                        </div>
                                    </td>
                                    <th className='px-[24px] py-[16px] align-center font-normal'>
                                        Current A
                                    </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="pb-4 secondary">
                                            Current = (C0 + C1 * MotorLoad + C2 * (MotorLoad^2) + C3 * (MotorLoad^3) + C4 *
                                            (MotorLoad^4) + C5 * (MotorLoad^5)) *
                                            motorCurrent;
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                NamePlateCurrent : (C0,C1,C2,C3,C4,C5)
                                            </p>
                                            <p className="secondary-text">
                                                Selected motor current from ESP catalog (Dr_Motors table in database)
                                            </p>
                                            <p className="secondary-text">
                                                MotorLoad = TotalBHP / (motorHP * frequency / 60);
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                motorHP = deratingPerformance.HP;
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                TotalBHP :
                                            </p>
                                            <p className="secondary-text">
                                                Total power required @ opearting frequency - Motor tab
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary">
                                                motorCurrent :
                                            </p>
                                            <p className="secondary-text">
                                                motorCurrent = deratingPerformance.Current;
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                                    <th className='px-[24px] py-[16px] align-center font-normal'>
                                        Voltage V
                                    </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div>
                                            <p className="secondary">
                                                Voltage = (motorVoltage * frequency / 60);
                                            </p>
                                            <p className="secondary-text">
                                                motorVoltage = deratingPerformance.Voltage;
                                            </p>
                                        </div>
                                    </td>
                                    <th className='px-[24px] py-[16px] align-center font-normal'>
                                        Power factor
                                    </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="pb-4 secondary">
                                            PowerFactor = P0 + P1 * MotorLoad + P2 * (MotorLoad^2) + P3 * (MotorLoad^3) + P4
                                            * (MotorLoad^4) + P5 * (MotorLoad^5)
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                NamePlatePowerFactor : (P0,P1,P2,P3,P4,P5)
                                            </p>
                                            <p className="secondary-text">
                                                Selected motor PowerFactor from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorLoad = TotalBHP / (motorHP * frequency / 60);
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                TotalBHP :
                                            </p>
                                            <p className="secondary-text">
                                                Total power required @ opearting frequency - Motor tab
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary">
                                                motorHP :
                                            </p>
                                            <p className="secondary-text">
                                                motorHP = deratingPerformance.HP;
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="align-center text-[14px] font-normal">
                                    <th className='px-[24px] py-[16px] align-center font-normal'>
                                        kW
                                    </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="secondary">
                                            <p>
                                                V<small>d</small> * I<small>d</small> * PF<small>d</small> *
                                                <span>&#8730;</span>3 / 1000
                                            </p>
                                        </div>
                                    </td>
                                    <th className='px-[24px] py-[16px] align-center font-normal'>
                                        Power hp
                                    </th>
                                    <td className='px-[24px] py-[16px]'>
                                        <div className="secondary">
                                            <p className="secondary">
                                                PowerHP = motorHP * frequency / 60;
                                            </p>
                                            <p className="secondary-text">
                                                motorHP = deratingPerformance.HP;
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                }
            ></Accordion>
            <Accordion
                title={LABELS?.motorRating}
                isOpen={!motorRatingCollapse}
                onToggle={() =>
                    handleCollapseChange(!motorRatingCollapse, "MotorDeratingCal")
                }
                id={'MotorDeratingCal'}
                content={
                    <>
                        <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
                            <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                                <table className="w-full table table-striped table-bordered dtr-inline">
                                    <colgroup>
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%" }} />
                                    </colgroup>
                                    <tr className="align-center border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                                        <th className='px-[24px] py-[16px] align-center font-normal'>
                                            HP
                                        </th>
                                        <td className='px-[24px] py-[16px]'>
                                            <div className="pb-4 secondary">
                                                HP = puHP * motorBaseHP
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">
                                                    motorBaseHP = motorDetails["BaseHP"]
                                                </p>
                                            </div>
                                            <div>
                                                <p className="secondary">
                                                    PUHP :
                                                </p>
                                                <p className="secondary-text">
                                                    PUHP =(TotalBHP / motorHP)
                                                </p>
                                            </div>
                                        </td>
                                        <th className='px-[24px] py-[16px] align-center font-normal'>
                                            Volts
                                        </th>
                                        <td className='px-[24px] py-[16px]'>
                                            <div className="secondary">
                                                <div className="pb-4 secondary">
                                                    voltage = motorVoltage * (V3 * (puHP^3) + V2 * (puHP^2) + V1 * puHP + V0)
                                                </div>
                                                <div className="pb-4">
                                                    <p className="secondary">
                                                        PUHP = (TotalBHP / motorHP)
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary-text">
                                                    motorVoltage = motorDetails["Voltage"]
                                                </p>
                                                <p className="secondary-text">
                                                </p>
                                            </div>
                                            <div>
                                                <p className="secondary">
                                                    NamePlatevoltage : (V0,V1,V2,V3,V4,V5)
                                                </p>
                                                <p className="secondary-text">
                                                    Selected motor voltage from ESP catalog (Dr_Motors table in database)
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="align-center text-[14px] font-normal">
                                        <th className='px-[24px] py-[16px] align-center font-normal'>
                                            Amps
                                        </th>
                                        <td className='px-[24px] py-[16px]'>
                                            <div className="secondary">
                                                <div className="pb-4 secondary">
                                                    current = motorCurrent * (C3 * (puHP^3) + C2 * (puHP^2) + C1 * puHP + C0)
                                                </div>
                                                <div className="pb-4">
                                                    <p className="secondary">
                                                        motorCurrent = motorDetails["Current"]
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary-text">
                                                    PUHP = (TotalBHP / motorHP)
                                                </p>
                                                <p className="secondary-text">
                                                    motorHP = deratingPerformance.HP;
                                                </p>
                                            </div>
                                            <div>
                                                <p className="secondary">
                                                    NamePlateCurrent : (C0,C1,C2,C3,C4,C5)
                                                </p>
                                                <p className="secondary-text">
                                                    Selected motor current from ESP catalog (Dr_Motors table in database)
                                                </p>
                                            </div>
                                        </td>
                                        <th className='px-[24px] py-[16px] align-center font-normal'></th>
                                        <td className='px-[24px] py-[16px]'></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </>
                }
            ></Accordion>

            <Accordion
                title={LABELS?.fluidVelocityCheck}
                isOpen={!fluidVelocityCheckCollapse}
                id={'FluidVel'}
                link={'help?tab=Motor#FluidVel'}
                onToggle={() =>
                    handleCollapseChange(!fluidVelocityCheckCollapse, "FluidVel")
                }
                content={
                    <>
                        <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
                            <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                                <table className='w-full table table-striped table-bordered dtr-inline'>
                                    <colgroup>
                                        <col style={{ width: "50%", borderRight: "1px solid #4a5463" }} />
                                        <col style={{ width: "50%" }} />
                                    </colgroup>
                                    <tr className="align-center border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                                        <th className='align-center px-[24px] py-[16px] font-normal'>Total fluid velocity post motor </th>
                                        <td colSpan={3} className='col-6 auto-va px-[24px] py-[16px]'>
                                            <div className='pb-4 secondary'>
                                                flowrateGPM / (gapArea * 3.12)
                                            </div>
                                            <div className='pb-4'>
                                                <p className='secondary'>
                                                    flowrateGPM = flowrate / 34.4
                                                </p>
                                            </div>
                                            <div>
                                                <p className='secondary'>
                                                    gapArea = casingIDArea - motorODArea
                                                </p>
                                                <p className='secondary-text'>
                                                    casingIDArea = ((casingID / 2)^ 2) * 3.14159
                                                </p>
                                                <p className='secondary-text'>
                                                    motorODArea = 3.14159 * ((motorOD / 2)^2)
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="text-[14px] font-normal">
                                        <th className='px-[24px] py-[16px] align-center font-normal'>
                                            Total fluid velocity post motor with shroud
                                        </th>
                                        <td className="px-[24px] py-[16px]">
                                            <div className='pb-4 secondary'>FluidVelocity</div>
                                            <div className='pb-4'>
                                                <p className='secondary'>
                                                    Metric Unitsystem
                                                    <p className='secondary-text'>
                                                        liquidVolRate = VolumeOil * 6.29 + VolumeWater *
                                                        6.29
                                                    </p>
                                                    <p className='secondary'>
                                                        Imperial Unitsystemtem
                                                    </p>
                                                    <p className='secondary-text'>
                                                        liquidVolRate = VolumeOil + VolumeWater
                                                    </p>
                                                </p>
                                            </div>
                                            <div className='pb-4'>
                                                <p className='secondary'>Shroud is Selected</p>
                                                <p className='secondary'>
                                                    liquidVolRate and ShroudID and MotorOD is Selected
                                                </p>
                                                <p className='secondary'>
                                                    ShroudID and MotorOD are equal{" "}
                                                </p>
                                                <p className='secondary-text pb-4'>
                                                    FluidPastMotor = 0
                                                </p>
                                                <p className='secondary'>else </p>
                                                <p className='secondary-text'>
                                                    FluidPastMotor = 0.0119 * liquidVolRate / (ShroudID)^2
                                                    - (MotorOD ^2)
                                                </p>
                                            </div>
                                            <div>
                                                <p className='secondary'>
                                                    FluidPastMotor is selected{" "}
                                                </p>
                                                <p className='secondary'>Metric Unitsystem</p>
                                                <p className='secondary-text'>
                                                    FluidPastMotor = FluidPastMotor*0.3048
                                                </p>
                                                <p className='secondary'>Imperial Unitsystem</p>
                                                <p className='secondary-text'>
                                                    FluidVelocity = FluidPastMotor
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </>
                }
            ></Accordion>
        </div>
    );
};
export default Motor;
